import React from "react";
import _ from "lodash";
import { dater, dt_dater } from "../../helpers";
import { DateTime } from "luxon";

// ============================ FL ===============================
export function getFlightBasicData({ reservation, t }) {
  if (!reservation) return [];

  var output = [
    [t("origin"), reservation?.origin_meta?.[0]?.iata ?? ""],
    [t("destination"), reservation?.destination_meta?.[0]?.iata ?? ""],
    [t("reference"), reservation.reference],
    [
      t("outboundflightNumber"),
      (
        (reservation?.flight_data?.selectedFlight?.legs?.[0] ?? []).find(
          (o) => o.uid === reservation.flight_data.outbound
        )?.segments ?? []
      )
        .map((s) => s.flight_number)
        .join(", "),
    ],

    [t("outboundDeparture"), dater(reservation.outbound_departure)],
  ];

  const legs = reservation?.flight_data?.selectedFlight?.legs ?? [];
  if (legs.length > 1) {
    const flNumbers = _.last(legs)
      .find((o) => o.uid === reservation.flight_data.inbound)
      .segments.map((s) => s.flight_number)
      .join(", ");
    output.push([t("inboundflightNumber"), flNumbers]);
  }
  if (reservation.inbound_departure) {
    output.push([t("inboundDeparture"), dater(reservation.inbound_departure)]);
  }

  const extraOutput = [
    [
      t("created"),
      DateTime.fromISO(reservation.created).toLocaleString(
        DateTime.DATETIME_SHORT
      ),
    ],
    [
      t("status"),
      reservation.status === "CO"
        ? t("confirmed")
        : reservation.status === "CA"
        ? t("cancelled")
        : t("pending"),
    ],
  ];
  return [...output, ...extraOutput];
}

export function getFlightExtraData({ reservation, t }) {
  if (!reservation) return [];

  const output = [
    [
      t("freeCancellationAvailable"),
      reservation.non_refundable ? t("no") : t("yes"),
    ],
  ];

  const extraOutput = [
    [
      t("freeCancellationDeadline"),
      dt_dater(reservation.max_cancellation_date),
    ],
  ];
  return reservation.non_refundable ? output : [...output, ...extraOutput];
}

export function getFlightPax({ reservation, t }) {
  if (!reservation) return [];

  return (reservation?.guests ?? []).map((guest) => [
    [t("type"), guest.guest_type_display],
    [t("title"), guest.guest_title_display],
    [t("firstName"), guest.first_name],
    [t("lastName"), guest.last_name],
    [t("email"), guest.email],
    ["leadGuest", guest.group_leader ? <strong>{t("yes")}</strong> : ""],
  ]);
}
